// 3rd party imports
import * as React from 'react';

// Shared UI
import { useLocalization } from '@shared-ui/localization-context';

// ui
import { UitkSecondaryButton, UitkButtonSize } from 'uitk-react-button';

interface CopyButtonProps {
  value: string;
  onCopyClick?: () => void;
}

export const CopyButton: React.FunctionComponent<CopyButtonProps> = ({ value, onCopyClick }) => {
  const l10n = useLocalization();

  const [copied, setCopied] = React.useState(false);

  const copyBtnOnClick = () => {
    navigator.clipboard.writeText(value);

    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000);

    onCopyClick?.();
  };

  return (
    <UitkSecondaryButton className="CopyButton" onClick={copyBtnOnClick} size={UitkButtonSize.LARGE}>
      {copied
        ? l10n.formatText('product.quicklink.form.actions.copied')
        : l10n.formatText('product.quicklink.form.actions.copy')}
    </UitkSecondaryButton>
  );
};
